import React from 'react';
import { ButtonSize, OptionSelectionButton, usePopupManager } from 'ui-builder';
import { ConfirmDeletePopup, Popup, usePopupFormManager } from 'features/nekst-widgets';
import UpdateDetailsFieldsSetForm from '../CreateUpdate/UpdateDetailsFieldsSetForm';
import ManageAiTrainingDataWidget from '../../aitraining/ManageAiTrainingDataWidget';
import { DetailsFieldsSet, TeamPermission, useDetailsFieldsSetsService } from 'nekst-api';
import useSettingsNavigator from '../../../settingsNavigator';
import { useAuthorizationChecker } from 'authorization-scope';
import CopySetForm from './CopySetForm';
import CreatePlanFromSetForm from './CreatePlanFromSetForm';

export default function EditSetButton(
  props: {
    set: DetailsFieldsSet,
  }
) {
  const popupFormManager = usePopupFormManager();

  const popupManager = usePopupManager();

  const setService = useDetailsFieldsSetsService();

  const settingsNavigator = useSettingsNavigator();

  const { isGranted } = useAuthorizationChecker();

  return (
    <OptionSelectionButton
      text="Edit"
      size={ButtonSize.SMALL}
      options={[
        ...props.set.contractTemplateId && isGranted(TeamPermission.MANAGE_AI_TRAINING_DATA) ? [{
          label: 'AI Training',
          onSelected: () => {
            popupManager.openPopup(
              <Popup
                isBig
                title="AI Training"
                content={(<ManageAiTrainingDataWidget
                  contractTemplateId={props.set.contractTemplateId}
                />)}
              />
            );
          },
          value: 'ai_training'
        }] : [],
        {
          label: 'Rename',
          onSelected: () => {
            popupFormManager.openForm(<UpdateDetailsFieldsSetForm detailsSet={props.set} />);
          },
          value: 'name'
        },
        {
          label: 'Create Workflow',
          onSelected: () => {
            popupFormManager.openForm(
              <CreatePlanFromSetForm
                set={props.set}
              />
            );
          },
          value: 'plan',
        },
        ...isGranted(TeamPermission.MANAGE_AI_TRAINING_DATA)? [{
          label: 'Copy Set',
          onSelected: () => {
            popupFormManager.openForm(
              <CopySetForm
                detailsSet={props.set}
              />
            );
          },
          value: 'copy',
        }] : [],
        ...isGranted(TeamPermission.DELETE_DETAILS_FIELDS_SET) ? [{
          label: 'Delete Set',
          onSelected: () => {
            popupManager.openPopup(
              <ConfirmDeletePopup
                deleteFunc={async () => {
                  await setService.deleteSet(props.set.id);
                  settingsNavigator.openProjectDetailsFieldPage(props.set.projectType);
                }}
                message={`Are you sure you want to delete "${props.set.name}" set?`}
              />
            );
          },
          value: 'delete',
        }] : [],
      ]}
    />
  );
}
